import createReducer from '../../utils/createReducer';
import {
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_ERROR,
  GET_STATES_SUCCESS,
  GET_STATES_ERROR,
} from '../../actions/common/commonConstants';

const initialState = {
  countries: [],
  states: [],
  error: '',
};

export default createReducer(
  {
    [GET_COUNTRIES_SUCCESS]: getCountries,
    [GET_COUNTRIES_ERROR]: getCountriesError,
    [GET_STATES_SUCCESS]: getStates,
    [GET_STATES_ERROR]: getStatesError,
  },
  initialState,
);

function getCountries(state, { payload }) {
  return {
    ...state,
    countries: payload,
    error: '',
  };
}

function getCountriesError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function getStates(state, { payload }) {
  return {
    ...state,
    states: payload,
    error: '',
  };
}

function getStatesError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
